<ion-alert
  [isOpen]="isOpen"
  subHeader="Confirmation"
  [message]="message"
  [buttons]="buttons"
  (didDismiss)="onDidDismiss()"
  class="alert alert-confirm"
></ion-alert>
